import type { SVGProps } from "react";
export default function SvgPresentation(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M2 3h20" />
			<path d="M21 3v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3" />
			<path d="m7 21 5-5 5 5" />
		</svg>
	);
}
